import { render } from "./Sure.vue?vue&type=template&id=b606ed28&scoped=true"
import script from "./Sure.vue?vue&type=script&lang=js"
export * from "./Sure.vue?vue&type=script&lang=js"

import "./Sure.vue?vue&type=style&index=0&id=b606ed28&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b606ed28"]])

export default __exports__